/* eslint-disable no-undef */
// @ts-nocheck
/**
 * LS Accessibility Fixes
 * Automatically fixes common accessibility issues across the site
 * Runs after page load to patch third-party and dynamic elements
 */

(function() {
  'use strict';

  var A11yFixes = {

    // Fix dialogs without accessible names
    fixDialogs: function() {
      var dialogs = document.querySelectorAll('[role="dialog"]:not([aria-label]):not([aria-labelledby])');

      dialogs.forEach(function(dialog) {
        // Try to find a title inside the dialog
        var title = dialog.querySelector('h1, h2, h3, [class*="title"], [class*="header"]');

        if (title && title.id) {
          dialog.setAttribute('aria-labelledby', title.id);
        } else if (title && title.textContent.trim()) {
          // Create an ID for the title
          var titleId = 'dialog-title-' + Math.random().toString(36).substr(2, 9);
          title.id = titleId;
          dialog.setAttribute('aria-labelledby', titleId);
        } else {
          // Fallback: use aria-label based on dialog class/id
          var label = 'Dialog';
          var id = dialog.id || '';
          var className = dialog.className || '';

          if (id.toLowerCase().indexOf('wishlist') > -1 || className.toLowerCase().indexOf('wishlist') > -1) {
            label = 'Wishlist';
          } else if (id.toLowerCase().indexOf('cart') > -1 || className.toLowerCase().indexOf('cart') > -1) {
            label = 'Shopping Cart';
          } else if (id.toLowerCase().indexOf('search') > -1 || className.toLowerCase().indexOf('search') > -1) {
            label = 'Search';
          } else if (id.toLowerCase().indexOf('menu') > -1 || className.toLowerCase().indexOf('menu') > -1) {
            label = 'Navigation Menu';
          } else if (id.toLowerCase().indexOf('quick') > -1 || className.toLowerCase().indexOf('quick') > -1) {
            label = 'Quick View';
          }

          dialog.setAttribute('aria-label', label);
        }
      });

      // Fix alertdialogs too
      var alertDialogs = document.querySelectorAll('[role="alertdialog"]:not([aria-label]):not([aria-labelledby])');
      alertDialogs.forEach(function(dialog) {
        dialog.setAttribute('aria-label', 'Alert');
      });
    },

    // Fix duplicate ARIA IDs
    fixDuplicateIds: function() {
      var allIds = {};
      var elementsWithId = document.querySelectorAll('[id]');

      elementsWithId.forEach(function(el) {
        var id = el.id;
        if (!id) return;

        if (allIds[id]) {
          // Duplicate found - rename this one
          var newId = id + '-' + Math.random().toString(36).substr(2, 5);
          el.id = newId;

          // Update any aria-labelledby or aria-describedby pointing to old ID
          // (only for elements that come after this one)
          var referencingElements = document.querySelectorAll(
            '[aria-labelledby="' + id + '"], [aria-describedby="' + id + '"], [aria-controls="' + id + '"]'
          );
          // We don't update these as they likely point to the first instance intentionally
        } else {
          allIds[id] = true;
        }
      });
    },

    // Fix iframes without titles
    fixIframes: function() {
      var iframes = document.querySelectorAll('iframe:not([title])');

      iframes.forEach(function(iframe) {
        var src = iframe.src || '';
        var id = iframe.id || '';
        var title = 'Embedded content';

        if (src.indexOf('youtube') > -1 || src.indexOf('youtu.be') > -1) {
          title = 'YouTube video player';
        } else if (src.indexOf('vimeo') > -1) {
          title = 'Vimeo video player';
        } else if (src.indexOf('maps.google') > -1 || src.indexOf('google.com/maps') > -1) {
          title = 'Google Maps';
        } else if (src.indexOf('preview-bar') > -1 || id.indexOf('Preview') > -1 || id.indexOf('PBar') > -1) {
          title = 'Shopify Preview Bar';
        } else if (src.indexOf('shopify') > -1) {
          title = 'Shopify embedded content';
        } else if (src.indexOf('instagram') > -1) {
          title = 'Instagram embed';
        } else if (src.indexOf('facebook') > -1 || src.indexOf('fb.com') > -1) {
          title = 'Facebook embed';
        } else if (src.indexOf('twitter') > -1 || src.indexOf('x.com') > -1) {
          title = 'Twitter/X embed';
        }

        iframe.setAttribute('title', title);
      });
    },

    // Fix images without alt text (backup for auto-alt-text)
    fixImages: function() {
      var images = document.querySelectorAll('img:not([alt])');

      images.forEach(function(img) {
        // Check if it's decorative (very small or has specific classes)
        var width = img.width || parseInt(img.getAttribute('width')) || 0;
        var height = img.height || parseInt(img.getAttribute('height')) || 0;

        if ((width > 0 && width < 10) || (height > 0 && height < 10)) {
          img.setAttribute('alt', '');
          img.setAttribute('role', 'presentation');
        } else {
          img.setAttribute('alt', 'Image');
        }
      });
    },

    // Fix buttons without accessible names
    fixButtons: function() {
      var buttons = document.querySelectorAll('button:not([aria-label]):not([aria-labelledby])');

      buttons.forEach(function(btn) {
        // Skip if has text content
        if (btn.textContent.trim()) return;

        // Check for icon-only buttons
        var svg = btn.querySelector('svg');
        var img = btn.querySelector('img');
        var className = btn.className || '';

        var label = 'Button';

        if (className.indexOf('close') > -1 || className.indexOf('dismiss') > -1) {
          label = 'Close';
        } else if (className.indexOf('prev') > -1 || className.indexOf('left') > -1) {
          label = 'Previous';
        } else if (className.indexOf('next') > -1 || className.indexOf('right') > -1) {
          label = 'Next';
        } else if (className.indexOf('search') > -1) {
          label = 'Search';
        } else if (className.indexOf('menu') > -1 || className.indexOf('hamburger') > -1) {
          label = 'Menu';
        } else if (className.indexOf('cart') > -1) {
          label = 'Cart';
        } else if (className.indexOf('wishlist') > -1 || className.indexOf('heart') > -1) {
          label = 'Add to Wishlist';
        } else if (className.indexOf('play') > -1) {
          label = 'Play';
        } else if (className.indexOf('pause') > -1) {
          label = 'Pause';
        } else if (className.indexOf('mute') > -1 || className.indexOf('volume') > -1) {
          label = 'Toggle sound';
        } else if (className.indexOf('zoom') > -1) {
          label = 'Zoom';
        } else if (className.indexOf('share') > -1) {
          label = 'Share';
        }

        btn.setAttribute('aria-label', label);
      });
    },

    // Fix links without accessible names
    fixLinks: function() {
      var links = document.querySelectorAll('a:not([aria-label]):not([aria-labelledby])');

      links.forEach(function(link) {
        // Skip if has text content
        if (link.textContent.trim()) return;

        // Skip if has accessible image
        var img = link.querySelector('img[alt]:not([alt=""])');
        if (img) return;

        var href = link.href || '';
        var className = link.className || '';
        var label = 'Link';

        if (className.indexOf('logo') > -1 || href === window.location.origin + '/') {
          label = 'Home';
        } else if (className.indexOf('social') > -1 || className.indexOf('facebook') > -1) {
          label = 'Facebook';
        } else if (className.indexOf('instagram') > -1) {
          label = 'Instagram';
        } else if (className.indexOf('twitter') > -1 || className.indexOf('x-') > -1) {
          label = 'Twitter/X';
        } else if (className.indexOf('youtube') > -1) {
          label = 'YouTube';
        } else if (className.indexOf('pinterest') > -1) {
          label = 'Pinterest';
        } else if (className.indexOf('tiktok') > -1) {
          label = 'TikTok';
        }

        link.setAttribute('aria-label', label);
      });
    },

    // Fix form inputs without labels
    fixFormInputs: function() {
      var inputs = document.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"])');

      inputs.forEach(function(input) {
        var id = input.id;
        if (!id) return;

        // Check if already has label
        var label = document.querySelector('label[for="' + id + '"]');
        if (label) return;

        // Check for aria-label
        if (input.getAttribute('aria-label')) return;

        // Try to create label from placeholder or name
        var placeholder = input.placeholder;
        var name = input.name;

        if (placeholder) {
          input.setAttribute('aria-label', placeholder);
        } else if (name) {
          // Convert name to readable label (e.g., "email_address" -> "Email address")
          var readableName = name.replace(/[_-]/g, ' ').replace(/([A-Z])/g, ' $1').trim();
          readableName = readableName.charAt(0).toUpperCase() + readableName.slice(1).toLowerCase();
          input.setAttribute('aria-label', readableName);
        }
      });
    },

    // Fix skip links
    ensureSkipLink: function() {
      var skipLink = document.querySelector('a[href="#MainContent"], a[href="#main"], .skip-link');
      if (!skipLink) {
        // Check if main content exists
        var main = document.querySelector('#MainContent, main, [role="main"]');
        if (main && !main.id) {
          main.id = 'MainContent';
        }
      }
    },

    // Run all fixes
    init: function() {
      var self = this;

      // Run fixes after a short delay to catch dynamically added content
      function runFixes() {
        self.fixDialogs();
        self.fixDuplicateIds();
        self.fixIframes();
        self.fixImages();
        self.fixButtons();
        self.fixLinks();
        self.fixFormInputs();
        self.ensureSkipLink();
      }

      // Initial run
      if (window.requestIdleCallback) {
        requestIdleCallback(runFixes, { timeout: 3000 });
      } else {
        setTimeout(runFixes, 1000);
      }

      // Run again after dynamic content loads
      if (window.MutationObserver) {
        var timeout;
        var observer = new MutationObserver(function() {
          clearTimeout(timeout);
          timeout = setTimeout(runFixes, 500);
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        // Disconnect after 30 seconds to save resources
        setTimeout(function() {
          observer.disconnect();
        }, 30000);
      }

      // Handle Shopify section loads
      document.addEventListener('shopify:section:load', function() {
        setTimeout(runFixes, 200);
      });
    }
  };

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      A11yFixes.init();
    });
  } else {
    A11yFixes.init();
  }

  // Expose for manual use
  window.A11yFixes = A11yFixes;

})();
